import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import LogActions from './log.actions';

@Injectable()
export class LogFacade {
    private readonly store = inject(Store);

    public sentInvalidUserTariffLog(): void {
        this.store.dispatch(LogActions.sendInvalidUserTariffLog());
    }
}
